export default "__VITE_ASSET__BoM_4IKl__"